import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  useEffect(() => {
    document.title = '404 Page Not Found – PaveMend';
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      document.title =
        'PaveMend – Driveways, Patios & Paving in South East London';
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div className="not-found">
      <div className="not-found__inner">
        <span className="not-found__code">404</span>
        <h1 className="not-found__title">Page Not Found</h1>
        <p className="not-found__sub">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="btn-primary not-found__cta">
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
